import * as moment from 'moment';
import {
  DateRangePickerLocaleConfig,
  DefaultDateRangePickerLocaleConfig,
} from './date-range-picker.locale-config';
import { DateRangePickerInputEvent } from './date-range-picker-range.model';

export interface DateRangePickerOptionsInterface {
  minDate?: Date;
  maxDate?: Date;
  autoApply?: boolean;
  showDropdowns?: boolean;
  showWeekNumbers?: boolean;
  showISOWeekNumbers?: boolean;
  linkedCalendars?: boolean;
  showCurrentDateOnRight?: boolean;
  autoFocusMonthInView?: boolean;
  autoUpdateInput?: boolean;
  maxSpan?: number;
  firstMonthDayClass?: string;
  lastMonthDayClass?: string;
  emptyWeekRowClass?: string;
  firstDayOfNextMonthClass?: string;
  lastDayOfPreviousMonthClass?: string;
  locale?: DateRangePickerLocaleConfig;
  ranges?: DateRangePickerInputEvent[];
  dateFormat?: string;
  dateLimit?: number;
  clearable?: boolean;
  isShowAsDate?: boolean;
}

export const DefaultDateRangePickerOptions: DateRangePickerOptionsInterface = {
  minDate: null,
  maxDate: null,
  autoApply: false,
  showDropdowns: false,
  showWeekNumbers: false,
  showISOWeekNumbers: false,
  linkedCalendars: true,
  showCurrentDateOnRight: false,
  autoFocusMonthInView: true,
  autoUpdateInput: false,
  maxSpan: 0,
  firstMonthDayClass: null,
  lastMonthDayClass: null,
  emptyWeekRowClass: null,
  firstDayOfNextMonthClass: null,
  lastDayOfPreviousMonthClass: null,
  locale: DefaultDateRangePickerLocaleConfig,
  ranges: [],
  dateFormat: 'dd LLL yyyy',
  dateLimit: null,
  clearable: true,
  isShowAsDate: false,
};
